import * as types from '../constants/actionTypes';

const initialState = {
  user: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_USER:
      return { ...state, user: action.payload };

    case types.RESET:
      return initialState;

    case types.LOGOUT:
      return initialState;

    default:
      return state;
  }
};
